// URL is the single source of truth for public-page language: ?lang=ar → Arabic, anything else → English.
const LANG_NEUTRAL = /^\/(api|admin|static)(\/|$)/;

export function langFromSearch(search) {
  return new URLSearchParams(search || "").get("lang") === "ar" ? "ar" : "en";
}

export function isLangNeutralPath(pathname) {
  return LANG_NEUTRAL.test(pathname || "/");
}

// Add/remove ?lang=ar on an internal href, keeping other params and the #fragment.
export function withLang(to, lang) {
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) return to;
  const hashIdx = to.indexOf("#");
  const hash = hashIdx >= 0 ? to.slice(hashIdx) : "";
  const rest = hashIdx >= 0 ? to.slice(0, hashIdx) : to;
  const qIdx = rest.indexOf("?");
  const path = qIdx >= 0 ? rest.slice(0, qIdx) : rest;
  if (isLangNeutralPath(path)) return to;
  const params = new URLSearchParams(qIdx >= 0 ? rest.slice(qIdx + 1) : "");
  if (lang === "ar") params.set("lang", "ar");
  else params.delete("lang");
  const qs = params.toString();
  return `${path || "/"}${qs ? `?${qs}` : ""}${hash}`;
}
